<template>
  <div @click="searchJobs" class="bytedance-button" :class="`bytedance-button-${size}`">
    <span>
      <slot>bytedance-button</slot>
    </span>
  </div>
</template>
<script>
export default {
  name: "bytedance-button",
  props: {
    size: {
      type: String,
      default: "medium",
      validator(value) {
        return ["small", "medium", "large"].includes(value);
      }
    }
  },
  methods: {
    searchJobs(keyword) {
      window.open('https://alidocs.dingtalk.com/notable/share/form/v01AJdl64NdyjWaqke1_1jwjlvL_fZj887i', '_blank');
    },
  }
};
</script>
<style lang="less" scoped>
.bytedance-button {
  text-align: center;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: @main-color;
  color: #fff;
  overflow: hidden;
  border-radius: 20px;
  position: relative;
  cursor: pointer;
  &:hover :after {
    content: "";
    position: absolute;
    background-color: rgba(255, 255, 255, 0.3);
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
  &-small {
    height: 20px;
  }
  &-large {
    height: 40px;
  }
}
</style>
